module.exports = __webpack_public_path__ + "static/media/imageTarget.ba976099.png";